import { AbTestId } from '@/types/ocelotConfig/utils';
import { getOcelotConfig } from 'lib/configs/ocelot';
import { useAppState } from './useAppState';

export const useAbTestVariant = (testId: AbTestId) => {
  const [{ abTestVariants }] = useAppState();
  const testConfig = getOcelotConfig('abTesting').tests.find((test) => test.id === testId);

  return { testConfig, resolvedVariant: abTestVariants?.[testId] };
};
